export default __webpack_public_path__ + "static/media/correspondent.238bc433.svg";